/* =============================================================
   ENVIRONMENT
   =============================================================
   The single place that reads `import.meta.env`. Everything else
   imports from here, so there is exactly one list of the variables
   this app understands (mirrored in `.env.example`).

   Remember: anything in here ships to the browser. Public keys only.
   ============================================================= */

function str(value: unknown, fallback = ''): string {
  return typeof value === 'string' && value.trim() !== '' ? value.trim() : fallback
}

export const env = {
  /** 'development' during `npm run dev`, 'production' in a built bundle. */
  mode: import.meta.env.MODE,
  isDev: import.meta.env.DEV,

  /** Branding overrides — let one build serve several white-label deployments. */
  appName: str(import.meta.env.VITE_APP_NAME),
  appOrg: str(import.meta.env.VITE_APP_ORG),
  marketingUrl: str(import.meta.env.VITE_MARKETING_URL),
  supportEmail: str(import.meta.env.VITE_SUPPORT_EMAIL),

  /** Supabase — intentionally empty until the project is created. */
  supabaseUrl: str(import.meta.env.VITE_SUPABASE_URL),
  supabaseAnonKey: str(import.meta.env.VITE_SUPABASE_ANON_KEY),
} as const

/**
 * True once both Supabase variables are present. `src/lib/auth/client.ts`
 * uses this to decide between the local stand-in and the real backend, so
 * wiring Supabase up is a matter of setting env vars, not editing code.
 */
export const isSupabaseConfigured = Boolean(env.supabaseUrl && env.supabaseAnonKey)
